<h2 mat-dialog-title>Kommentarer för standardgrupp {{ reportStandardGroupName }}</h2>
<form #form="ngForm" [formGroup]="reportStandardGroupForm" (ngSubmit)="save(true)" novalidate class="flex-col gap-1em" autocomplete="off">
  <mat-dialog-content>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Kommentarer</mat-label>
        <textarea matInput rows="8" formControlName="comment"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (hasPermissionToChange$ | async) {
      <button mat-raised-button type="submit" color="primary" title="{{'commands.SaveAndClose' | translate }}">{{ 'commands.SaveAndClose' | translate }}</button>
    }
    @if (hasPermissionToChange$ | async) {
      <button mat-raised-button type="button" (click)="save(false)" color="accent" title="{{'commands.Save' | translate }}">{{ 'commands.Save' | translate }}</button>
    }
    <button mat-raised-button type="button" (click)="cancel()">{{ 'commands.Close' | translate }}</button>
  </mat-dialog-actions>
</form>
